//@flow
import { createSelector } from 'reselect';
import { clientIdSelector } from 'common/redux/selectors/sessionSelector';
import { List } from 'immutable';

export const getSalesCategories = createSelector(
    [clientIdSelector, state => state.salesCategories],
    (clientId, clientState) => clientState.getIn([clientId, 'salesCategories'])
);

export const getOutletSalesCategories = createSelector(
    [clientIdSelector, state => state.salesCategories],
    (clientId, clientState) =>
        clientState.getIn([clientId, 'outletSalesCategories'])
);

export const getDefaultSalesCategoriesCapacitiesList = createSelector(
    [getOutletSalesCategories],
    pjpSalesCategories => {
        return (
            pjpSalesCategories &&
            pjpSalesCategories.map(salesCategory => {
                return {
                    id: salesCategory.id,
                    value: salesCategory.capacity,
                    label: salesCategory.name,
                    checked: true
                };
            })
        );
    }
);

const transfromSalesCategories = (
    salesCategories: Immutable.Map<string, Array<string>>
): Array<string> => {
    return salesCategories
        ? Object.values(salesCategories.toJS())
              .map(group => group.categories)
              .flat()
        : [];
};

export const getAssignableSalesCategories = ({
    salesCategories,
    assignedSalesCategories = List()
}: {
    assignedSalesCategories: Array<string>
}): Immutable.List<Object> => {
    const uniqueAssignedSalesCategories = [
        ...new Set(transfromSalesCategories(assignedSalesCategories))
    ];
    const assignableSalesCategories = salesCategories?.filter(
        ({ id }) => !uniqueAssignedSalesCategories.includes(id)
    );
    return assignableSalesCategories;
};

export const getAssignableCapacities = ({
    salesCategories,
    assignedSalesCategories = List()
}: {
    assignedSalesCategories: Array<string>
}): Immutable.List<Object> => {
    const uniqueAssignedSalesCategories = [
        ...new Set(transfromSalesCategories(assignedSalesCategories))
    ];
    const assignableSalesCategories = salesCategories?.filter(
        ({ value }) => !uniqueAssignedSalesCategories.includes(value)
    );
    return assignableSalesCategories;
};
